let init = false;
let swiper;

/**
 * Initialises Swiper instances for different sections.
 */
function initialiseSwipers() {
	const swipers = document.querySelectorAll('.swiper');

	if (!swipers.length) return;

	const swiperAccouncement = new Swiper('.swiper--announcement', {
		slidesPerView: 1,
		grabCursor: true,
		effect: "fade",
		fadeEffect: { crossFade: true },
		loop: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: true,
		},
	});

	/* Featured collections tabs (home page) — one swiper per panel,
	   shared prev/next controls acting on the active panel. */
	const fcRoot = document.querySelector('[data-featured-collections]');
	if (fcRoot) {
		const fcSwipers = {};
		let fcActive = null;

		fcRoot.querySelectorAll('[data-fc-panel]').forEach((panel) => {
			const handle = panel.dataset.fcPanel;
			if (fcActive === null) fcActive = handle;
			fcSwipers[handle] = new Swiper(panel.querySelector('.swiper--fc'), {
				slidesPerView: 2.25,
				spaceBetween: 8,
				grabCursor: true,
				keyboard: { enabled: true },
				observer: true,
				observeParents: true,
				breakpoints: {
					768: { slidesPerView: 3, spaceBetween: 16 },
					1280: { slidesPerView: 4, spaceBetween: 16, },
				},
			});
		});

		const fcTabs = fcRoot.querySelectorAll('[data-fc-tab]');
		const fcPanels = fcRoot.querySelectorAll('[data-fc-panel]');
		const fcViewAll = fcRoot.querySelector('[data-fc-view-all]');

		fcTabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				const handle = tab.dataset.fcTab;
				if (handle === fcActive) return;
				fcActive = handle;

				fcTabs.forEach((t) => {
					const isActive = t === tab;
					t.classList.toggle('is-active', isActive);
					t.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});

				fcPanels.forEach((panel) => {
					const isActive = panel.dataset.fcPanel === handle;
					panel.classList.toggle('is-active', isActive);
					panel.hidden = !isActive;
				});

				if (fcViewAll) fcViewAll.href = '/collections/' + handle;

				const activeSwiper = fcSwipers[handle];
				if (activeSwiper) activeSwiper.update();
			});
		});

		const fcPrev = fcRoot.querySelector('[data-fc-prev]');
		const fcNext = fcRoot.querySelector('[data-fc-next]');
		if (fcPrev) {
			fcPrev.addEventListener('click', () => {
				if (fcSwipers[fcActive]) fcSwipers[fcActive].slidePrev();
			});
		}
		if (fcNext) {
			fcNext.addEventListener('click', () => {
				if (fcSwipers[fcActive]) fcSwipers[fcActive].slideNext();
			});
		}
	}

	const swiperSlushies = new Swiper('.swiper--slushies', {
		slidesPerView: 2,
		spaceBetween: 16,
		grabCursor: true,
		keyboard: { enabled: true },
		navigation: {
			nextEl: '.swiper-button-prev--slushies',
			prevEl: '.swiper-button-next--slushies',
		},
		breakpoints: {
			768: { slidesPerView: 3 },
			1280: { slidesPerView: 4 },
		},
	});

	const swiperSlushieBundles = new Swiper('.swiper--slushie-bundles', {
		slidesPerView: 2,
		spaceBetween: 16,
		grabCursor: true,
		keyboard: { enabled: true },
		navigation: {
			nextEl: '.swiper-button-prev--slushie-bundles',
			prevEl: '.swiper-button-next--slushie-bundles',
		},
		breakpoints: {
			768: { slidesPerView: 3 },
			1280: { slidesPerView: 4 },
		},
	});

	const productSlides = document.querySelectorAll('.swiper--product .swiper-slide');
	const slidesCount = productSlides.length;

	const swiperThumbnails = new Swiper('.swiper--thumbnails', {
		slidesPerView: 5.5,
		spaceBetween: 8,
		direction: 'horizontal',
		loop: true,
		breakpoints: {
			1024: {
				direction: 'vertical',
				slidesPerView: 2,
				spaceBetween: 14,
			},
		},
	});

	swiperProduct = new Swiper('.swiper--product', {
		spaceBetween: 10,
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		thumbs: {
			swiper: swiperThumbnails,
		},
		breakpoints: {
			1728: {
				slidesPerView: 1,
			},
		},
	});

	swiperAccomm = new Swiper('.swiper--accomm', {
		slidesPerView: 1,
		spaceBetween: 10,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: "fraction",
		},
	});

	const swiperBrewery01 = new Swiper('#swiper-brewery-01', {
		slidesPerView: 1,
		grabCursor: true,
		keyboard: { enabled: true },
		navigation: {
			nextEl: '.swiper-controls-01 .swiper-button-next',
			prevEl: '.swiper-controls-01 .swiper-button-prev',
		},
		pagination: {
			el: '.swiper-controls-01 .swiper-pagination',
			clickable: true,
		},
	});

	const swiperBrewery02 = new Swiper('#swiper-brewery-02', {
		slidesPerView: 1,
		grabCursor: true,
		keyboard: { enabled: true },
		navigation: {
			nextEl: '.swiper-controls-02 .swiper-button-next',
			prevEl: '.swiper-controls-02 .swiper-button-prev',
		},
		pagination: {
			el: '.swiper-controls-02 .swiper-pagination',
			clickable: true,
		},
	});

	const swiperBrewery03 = new Swiper('#swiper-brewery-03', {
		slidesPerView: 1,
		grabCursor: true,
		keyboard: { enabled: true },
		navigation: {
			nextEl: '.swiper-controls-03 .swiper-button-next',
			prevEl: '.swiper-controls-03 .swiper-button-prev',
		},
		pagination: {
			el: '.swiper-controls-03 .swiper-pagination',
			clickable: true,
		},
	});

	const swiperBrewery04 = new Swiper('#swiper-brewery-04', {
		slidesPerView: 1,
		grabCursor: true,
		keyboard: { enabled: true },
		navigation: {
			nextEl: '.swiper-controls-04 .swiper-button-next',
			prevEl: '.swiper-controls-04 .swiper-button-prev',
		},
		pagination: {
			el: '.swiper-controls-04 .swiper-pagination',
			clickable: true,
		},
	});

	/* ----------------------------------------------------------------------- */
	/*  Cart drawer upsell slider                                              */
	/* ----------------------------------------------------------------------- */

	if (document.querySelector('.swiper--upsell')) {
		new Swiper('.swiper--upsell', {
			slidesPerView: 1.4,
			spaceBetween: 10,
			grabCursor: true,
			navigation: {
				nextEl: '.upsell__arrow--next',
				prevEl: '.upsell__arrow--prev',
			},
			pagination: {
				el: '.swiper-pagination--upsell',
				clickable: true,
			},
		});
	}

	handleVariantRadios(swiperProduct);
	handleUpsellVariantSelects();
}

/**
 * Handles variant radio button clicks to update the Swiper slide.
 *
 * @param {Object} swiperProduct - The Swiper instance for the product.
 */
function handleVariantRadios(swiperProduct) {
	document.addEventListener('click', (event) => {
		const radio = event.target.closest('.variants__input');
		if (!radio || !radio.checked) return;

		const variantID = radio.getAttribute('data-variant-id');
		const variantMedia = document.querySelectorAll('.swiper-slide');
		variantMedia.forEach((elem) => {
			const variantSlide = elem.getAttribute('data-variant-id');
			if (variantSlide == variantID) {
				const slideIndex = elem.getAttribute('data-slide-id');
				swiperProduct.slideTo(slideIndex);
			}
		});
	});
}

/**
 * Handles variant <select> changes inside cart-drawer upsell cards.
 * Syncs the selected option to the hidden radio that productForm.js reads,
 * and updates the visible price text.
 */
function handleUpsellVariantSelects() {
	document.addEventListener('change', (event) => {
		const select = event.target.closest('[data-upsell-variant-select]');
		if (!select) return;

		const form = select.closest('[data-product-form]');
		if (!form) return;

		const option = select.options[select.selectedIndex];
		const radio = form.querySelector('[data-variant-input]');
		if (!radio || !option) return;

		radio.value = option.value;
		radio.dataset.price = option.dataset.price || '';
		radio.dataset.compare = option.dataset.compare || '';
		radio.dataset.packSizeQty = option.dataset.packSizeQty || '1';

		const priceEl = form.querySelector('[data-upsell-price]');
		if (priceEl && option.dataset.price) {
			const cents = Number(option.dataset.price);
			priceEl.textContent = (cents / 100).toLocaleString('en-AU', {
				style: 'currency',
				currency: 'AUD',
				minimumFractionDigits: 2,
			});
		}

		const packSizeQty = Number(option.dataset.packSizeQty || 1);
		const inventory = Number(form.dataset.singleUnitInventory || 0);
		const available = inventory >= packSizeQty;

		radio.dataset.available = available ? 'true' : 'false';

		const btn = form.querySelector('.upsell__atc');
		if (btn) {
			const label = btn.childNodes[0];
			if (available) {
				btn.setAttribute('data-product-submit', '');
				btn.disabled = false;
				if (label) label.textContent = btn.classList.contains('upsell__atc--full') ? 'Add to Cart' : 'Add';
			} else {
				btn.removeAttribute('data-product-submit');
				btn.disabled = true;
				if (label) label.textContent = 'Sold Out';
			}
		}
	});
}

// Initialise the event listeners when the DOM is fully loaded.
document.addEventListener('DOMContentLoaded', initialiseSwipers);
